import {z} from 'zod';
import {CreateCosSelectionOptionRequest} from '../api/generated/index.defs';
import {mapNullToUndefined} from '../utils/zod';

export const cosSelectionOptionSchema = z.object({
  label: z.string().min(1, 'Label is required'),
  days: z.number().min(1, 'Days must be greater than 0'),
  sortOrder: mapNullToUndefined(z.number().optional()),
  isActive: mapNullToUndefined(z.boolean().optional()),
}) satisfies z.Schema<CreateCosSelectionOptionRequest>;

export type CosSelectionOptionSchema = z.TypeOf<typeof cosSelectionOptionSchema>;
